/**
 * --------------------------------------------------------------------------
 * NJ : AbstractFormBase.js
 * --------------------------------------------------------------------------
 */

import AbstractComponent from 'nj-components/AbstractComponent';
import Testing from 'nj-utils/testing';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const CLASS_NAME = {
  njFormGroup: 'nj-form-group',
  isFilled: 'is-filled',
  isFocused: 'is-focused'
};

const SELECTOR = {
  formGroup: `.${CLASS_NAME.njFormGroup}`
};

class AbstractFormBase extends AbstractComponent {
  constructor(Component, element, config, properties) {
    super(Component, element, config, properties);

    if (this.constructor === AbstractFormBase) {
      throw new TypeError('Abstract class "AbstractFormBase" cannot be instantiated directly');
    }

    this.element = element;
    this.config = config;

    // set properties for use in the constructor initialization
    for (const key in properties) {
      if ({}.hasOwnProperty.call(properties, key)) {
        this[key] = properties[key];
      } else {
        console.error(`${key} does not exist in properties`);
      }
    }
  }

  addFormGroupFocus() {
    if (!this.element.disabled === true) {
      this.njFormGroup.classList.add(CLASS_NAME.isFocused);
    }
  }

  removeFormGroupFocus() {
    this.njFormGroup.classList.remove(CLASS_NAME.isFocused);
  }

  addIsFilled() {
    this.njFormGroup.classList.add(CLASS_NAME.isFilled);
  }

  removeIsFilled() {
    this.njFormGroup.classList.remove(CLASS_NAME.isFilled);
  }

  findFormGroup(raiseError = true) {
    const formGroup = this.element.closest(SELECTOR.formGroup);

    if (formGroup === null && raiseError) {
      console.error(
        `Failed to find ${SELECTOR.formGroup} for ${Testing.describe(
          this.element
        )}`
      );
    }
    return formGroup;
  }
}

export default AbstractFormBase;
